import type {Hit as AlgoliaHit} from "instantsearch.js";
import {Box, Text} from "@chakra-ui/react";
import Link from "next/link";

export type PageHit = AlgoliaHit<{
  url: string;
  title: string;
  description: string;
}>;

type HitProps = {
  hit: PageHit;
  onClose: () => void;
};

export const Hit = ({hit, onClose}: HitProps) => (
  <Link href={hit.url}>
    <Box p="4" onClick={onClose} _hover={{bg: "gray.50"}} borderBottom="1px solid #eee">
      <Text fontWeight="600">{hit.title?.split(" | Onemind Services")[0]}</Text>
      <Text fontSize="sm" color="gray.600">
        {hit.description}
      </Text>
    </Box>
  </Link>
);
